/** Same default as the tracking script. */
export const DEFAULT_CATEGORY_LEVEL = 2;
export const CATEGORY_LEVEL_OPTIONS: readonly number[] = [1, 2, 3, 4, 5];
